import { IServiceOption } from 'src/interfaces/reviews';

const serviceListData = [
  {
    label: 'Физлицам',
    legalValue: 'false',
  },
  {
    label: 'Юрлицам',
    legalValue: 'true',
  },
  {
    label: 'Другие',
    legalValue: 'other',
  },
];

export const getSpecialStructurForServices = (servicesList: IServiceOption[]) =>
  serviceListData
    .map((item) => {
      const serviceTree = servicesList.filter(({ legalValue }) => {
        return legalValue === item.legalValue;
      });
      if (serviceTree.length) {
        return { [item.label]: serviceTree };
      }
      return null;
    })
    .filter((item) => item !== null);
